import {
	computed,
	ref,
	Ref,
	watch,
} from '@vue/composition-api';

const ROLE_VERIFICATION_STATE_KEY_TEMPLATE = 'phx_user_verification';
const getStorageKeyForUser = (userId: string) => `${ROLE_VERIFICATION_STATE_KEY_TEMPLATE}_${userId}`;

export interface GetRoleVerificationRequestStateStore {
	/**
	 * Programatically get the saved date, if any, for the current user
	 */
	get(): void;
	/**
	 * Set the value for the current user to the current dateTime
	 */
	update(): void;
	/**
	 * Ref pointing to the current value of the stored date for the current user
	 */
	value: Ref<string | null>;
}

export function getRoleVerificationRequestStateStore(userId: Ref<string>): GetRoleVerificationRequestStateStore {
	const key = computed(() => getStorageKeyForUser(userId.value));
	const get = () => window.localStorage.getItem(key.value);
	const value: Ref<string | null> = ref('');
	const updateValueRef = () => {
		value.value = get();
	};
	watch(key, updateValueRef, { immediate: true });
	const update = () => {
		window.localStorage.setItem(key.value, new Date().toISOString());
		updateValueRef();
	};

	return {
		get,
		update,
		value,
	};
}
